import * as actionTypes from '../actions/actionTypes';

export default function caseOwnerReducer(state = [], action) {
  switch (action.type) {
    case actionTypes.SET_CASE_OWNER: {
      let newState = { ...state };
      newState = action.caseOwnerDetails;
      return newState;
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/caseOwnerReducer.js